import type { PermissionGroup, PermissionResource } from '../components/types';

export type NiederlassungRow = { id: number; nummer: number; bezeichnung: string };

/**
 * Ergänzt die statische `branch`-Gruppe aus permissionGroups.ts um alle Niederlassungen
 * aus der API (gleicher Trick wie Kalender: bezeichnungExists → keine Branch-Einschränkung).
 * Bekannte Standorte behalten ihre stabilen `id`-Strings aus der Config; neue erhalten `branch.<id>`.
 */
export function mergeBranchNiederlassungenIntoPermissionGroups(
    groups: PermissionGroup[],
    branches: NiederlassungRow[] | undefined
): PermissionGroup[] {
    if (!branches?.length) {
        return groups;
    }

    return groups.map((group) => {
        if (group.id !== 'branch') {
            return group;
        }

        const staticByValue = new Map<number, PermissionResource>(
            group.resources
                .filter((r): r is PermissionResource & { value: number } => r.value != null)
                .map((r) => [r.value, r])
        );

        const sorted = [...branches].sort((a, b) => a.nummer - b.nummer);
        const resources = sorted.map((branch) => {
            const staticRes = staticByValue.get(branch.id);
            return {
                id: staticRes?.id ?? `branch.${branch.id}`,
                name: staticRes?.name ?? branch.bezeichnung,
                value: branch.id,
                permissions: staticRes?.permissions ?? [],
            };
        });

        return { ...group, resources };
    });
}
